import { render, staticRenderFns } from "./formDetailsModal.vue?vue&type=template&id=64728087&"
import script from "./formDetailsModal.vue?vue&type=script&lang=js&"
export * from "./formDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./formDetailsModal.vue?vue&type=style&index=0&id=64728087&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports